import { NO_DATA } from "@/constants";
import { useTranslation } from "react-i18next";

export const useValueRenderer = () => {
  const { t } = useTranslation();
  return (value?: string | boolean | null, translationKey?: string) => {
    if (value === undefined || value === null || value === "") {
      return NO_DATA;
    }
    if (translationKey) {
      return t(`${translationKey}.${value}`);
    }
    return value.toString();
  };
};
